var _defs, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLandscape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.77 17.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:13.92px;fill:#3865ab;font-family:Tahoma;letter-spacing:0.2em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Metiri Text 40x150 (small text)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 12.02)"
  }, "metiri")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLandscape);
export default __webpack_public_path__ + "static/media/LogoLandscape.9edf5ac6f336a8ae2c6d975679957880.svg";
export { ForwardRef as ReactComponent };